/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {plaidLinkTokenCreate} from '../api'

export const useMutationPlaidLinkTokenCreate = createReactQueryMutationHook('plaidLinkTokenCreate', plaidLinkTokenCreate)
